<template>
  <div>
    <h2>Edit</h2>
    <hr>
    <multiselect v-model="adminEmail" :options="emailOptions" :multiple="false" :searchable="false" :close-on-select="true" :show-labels="false" placeholder=""></multiselect>
    <hr>
    <button class="mylisting-button dark-button mb-5" @click="updateUser()" style="float: right;">Update</button>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  props: ['user'],
  data() {
    return {
      // userType: ''
      adminEmail: '',
      emailOptions: [
        this.$store.getters.agencyAdminEmail,
        this.$store.getters.agencyAdminEmail2
      ],
    }
  },
  created() {
    // this.userType = this.user.selector1
    this.adminEmail = this.user.selector9
  },
  methods: {
    updateUser() {
      axios.patch(`/api/people/${this.user.id}/`, {
        selector9: this.adminEmail
      })
        .then(res => {
          this.$emit('userUpdated')
        })
        .catch(error => console.log(error))
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/employers/applications/ApplicationForm.vue